'use client';
export { default } from './components/hosting';
